export default __webpack_public_path__ + "static/media/architecture-img-18.ac66ed9d.jpg";